/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Guestlist_InvitedInputs */

const en_scene_guestlist_invited = /** @type {(inputs: Scene_Guestlist_InvitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invited`)
};

/**
* | output |
* | --- |
* | "Invited" |
*
* @param {Scene_Guestlist_InvitedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_guestlist_invited = /** @type {((inputs?: Scene_Guestlist_InvitedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Guestlist_InvitedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_guestlist_invited(inputs)
});